/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServicePackageOptionReference
 */
export interface ServicePackageOptionReference {
    /**
     * UUID of the Service Package Plan Option
     * @type {string}
     * @memberof ServicePackageOptionReference
     */
    id: string;
    /**
     * Name of the Service Package Plan Option
     * @type {string}
     * @memberof ServicePackageOptionReference
     */
    readonly name: string;
}

/**
 * Check if a given object implements the ServicePackageOptionReference interface.
 */
export function instanceOfServicePackageOptionReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ServicePackageOptionReferenceFromJSON(json: any): ServicePackageOptionReference {
    return ServicePackageOptionReferenceFromJSONTyped(json, false);
}

export function ServicePackageOptionReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServicePackageOptionReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ServicePackageOptionReferenceToJSON(value?: ServicePackageOptionReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

